/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_CreatingInputs */



/**
* | output |
* | --- |
* | "Creating..." |
*
* @param {User_CreatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_creating = /** @type {((inputs?: User_CreatingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_CreatingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Création...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Criando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione...")
	return /** @type {LocalizedString} */ ("Creating...")
});